import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { ClickEffect } from './components/layout/ClickEffect'

// Lazy-load PublicLayout to avoid blocking initial render
const PublicLayout = lazy(() => import('./components/layout/PublicLayout').then(m => ({ default: m.PublicLayout })))

// Route-based code splitting for faster initial load
const Landing = lazy(() => import('./pages/Landing').then(m => ({ default: m.Landing })))
const Login = lazy(() => import('./pages/Login').then(m => ({ default: m.Login })))
const Signup = lazy(() => import('./pages/Signup').then(m => ({ default: m.Signup })))
const Pricing = lazy(() => import('./pages/Pricing').then(m => ({ default: m.Pricing })))
const About = lazy(() => import('./pages/About').then(m => ({ default: m.About })))
const Faq = lazy(() => import('./pages/Faq').then(m => ({ default: m.Faq })))
const Dashboard = lazy(() => import('./pages/Dashboard').then(m => ({ default: m.Dashboard })))

// Loading fallback component
function RouteLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950">
      <div className="flex items-center gap-3 text-slate-300">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-600 border-t-cyan-400" />
        <span>Loading...</span>
      </div>
    </div>
  )
}

export function App() {
  return (
    <>
      {/* Canvas click-ripple — global, pointer-events-none, zero re-renders */}
      <ClickEffect />

      <ScrollToTop />
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/app" element={<Dashboard />} />
          </Route>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  )
}
